<template>
    <div>
        <div class="popup__header">
            <span class="title title--sm popup__title">{{ $lang('reset.title') }}</span>
            <span class="popup__header-description" v-html="$lang('reset.description')"></span>
        </div>
        <el-tabs :active-name="tab" class="popup__tabs" @tab-click="clearError">
            <el-tab-pane :label="$lang('reset.byEmail')" name="email">
                <div class="popup__content">
                    <errors :errors="errors"></errors>
                    <form class="form" @submit.prevent="reset('email')">
                        <div class="form__item">
                            <label class="form__inner">
                                <span class="form__label">{{ $lang('reset.label.email') }}</span>
                                <el-input class="input input--big" placeholder="email@info.com" v-model="email" required dusk="email-input"></el-input>
                            </label>
                        </div>
                        <div class="form__item">
                            <button class="btn btn--middle btn--main-bg" dusk="get-password-email">{{ $lang('reset.button.restore') }}</button>
                        </div>
                        <div v-if="showRegistration" class="form__item form__item--inline">
                            <span class="popup__auth-hint">{{ $lang('reset.hint') }}</span> <router-link class="link" :to="{name: 'registration', query: $route.query}"><span>{{ $lang('reset.button.register') }}</span></router-link>
                        </div>
                    </form>
                </div>
            </el-tab-pane>
            <el-tab-pane v-if="locale === 'ru'" :label="$lang('reset.byPhone')" name="phone">
                <div class="popup__content">
                    <errors :errors="errors"></errors>
                    <form class="form" @submit.prevent="reset('phone')">
                        <div class="form__item">
                            <label class="form__inner">
                                <span class="form__label">{{ $lang('reset.label.phone') }}</span>
                                <input-phone dusk="reset-pass-phone" class="input input--big" v-model="phone" required/>
                            </label>
                        </div>
                        <div class="form__item">
                            <button class="btn btn--middle btn--main-bg" dusk="get-password-sms">{{ $lang('reset.button.restore') }}</button>
                        </div>
                        <div v-if="showRegistration" class="form__item form__item--inline">
                            <span class="popup__auth-hint">{{ $lang('reset.hint') }}</span>
                            <router-link class="link" :to="{name: 'registration', query: $route.query}">
                                <span>{{ $lang('reset.button.register') }}</span>
                            </router-link>
                        </div>
                    </form>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Errors from "../../error/errors";
    import InputPhone from "../../../components/InputPhone";
    import { mapActions, mapState } from 'vuex';

    export default {
        name: "Email",
        components: {Errors, InputPhone},
        props: {
            showRegistration: {
                type: Boolean,
                default: true
            }
        },
        data: () => ({
            email: '',
            phone: '',
            errors: null,
            tab: 'email',
            locale: window.laravel.locale
        }),
        computed: {
            ...mapState('auth',[
                'formAuth',
            ]),
        },
        methods: {
            ...mapActions('auth', [
                'emailReset',
            ]),
            reset(value){
                let val = value === 'email' ? {email: this.email} : {phone: this.phone};
                this.emailReset(val)
                    .then((response) => {
                        let test = value === 'email' ? this.$lang('Email.passwordSendToEmail') : this.$lang('Email.passwordSendToPhone');
                        this.$appNotify.success(test);
                        this.$router.push({name: 'login', params: { showRegistration: this.showRegistration }, query: this.$route.query});
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                        console.log(error);
                    });
            },
            clearError(tab) {
                if (this.errors) {
                    this.errors = null;
                }
            }
        }
    }
</script>
